import React from 'react';

import styles from './WidgetHeader.module.scss';

const WidgetHeader = ({ title, titleClassname = 'title' }) => {
  return <h3 className={styles[titleClassname]}>{title}</h3>;
};

export default WidgetHeader;
